import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaInstagram, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import api from '../config/api';

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState({
    whatsapp: null,
    instagram: null,
    linkedin: null
  });

  useEffect(() => {
    fetchSocialLinks();
  }, []);

  const fetchSocialLinks = async () => {
    try {
      const token = localStorage.getItem('token');
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      const res = await api.get('/social-links', config);
      const links = res.data.data;

      const linksState = { whatsapp: null, instagram: null, linkedin: null };

      links.forEach(link => {
        if (link.isActive) {
          linksState[link.platform] = link.url;
        }
      });

      setSocialLinks(linksState);
    } catch (err) {
      console.error('Failed to fetch social links', err);
      setSocialLinks({
        instagram: 'https://www.instagram.com/officialstudentera',
        linkedin: 'https://www.linkedin.com/in/studentera'
      });
    }
  };

  return (
    <footer className="w-full bg-slate-900 text-slate-300 pt-16 pb-8 font-sans border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 pb-12 border-b border-slate-800">

        {/* Brand & Mission */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img src="/logo192.png" alt="Student Era Logo" className="w-10 h-10 rounded-full bg-white p-0.5" />
            <span className="text-xl font-extrabold text-white tracking-tight">Student Era</span>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
            Empowering students to bridge the gap between academic theory and real-world execution through verified virtual internships and professional training.
          </p>
          <div className="flex space-x-3 pt-2">
            {socialLinks.linkedin && (
              <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-all bg-slate-800 p-2.5 rounded-xl hover:bg-indigo-600 shadow-sm" aria-label="LinkedIn">
                <FaLinkedin className="h-4 w-4" />
              </a>
            )}
            {socialLinks.instagram && (
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-all bg-slate-800 p-2.5 rounded-xl hover:bg-pink-600 shadow-sm" aria-label="Instagram">
                <FaInstagram className="h-4 w-4" />
              </a>
            )}
          </div>
        </div>

        {/* Resources */}
        <div>
          <h3 className="font-bold text-white text-xs tracking-wider uppercase mb-5">Resources</h3>
          <ul className="space-y-3.5 text-sm text-slate-400 font-medium">
            <li><Link to="/internships" className="hover:text-indigo-400 transition-colors">Browse Internships</Link></li>
            <li><Link to="/verify-certificate" className="hover:text-indigo-400 transition-colors">Verify Certificate</Link></li>
            <li><Link to="/about" className="hover:text-indigo-400 transition-colors">About Us</Link></li>
            <li><Link to="/faq" className="hover:text-indigo-400 transition-colors">FAQ & Support</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h3 className="font-bold text-white text-xs tracking-wider uppercase mb-5">Legal</h3>
          <ul className="space-y-3.5 text-sm text-slate-400 font-medium">
            <li><Link to="/terms" className="hover:text-indigo-400 transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-indigo-400 transition-colors">Privacy Policy</Link></li>
            <li><Link to="/refund" className="hover:text-indigo-400 transition-colors">Refund Policy</Link></li>
            <li><Link to="/contact" className="hover:text-indigo-400 transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact info */}
        <div className="space-y-4">
          <h3 className="font-bold text-white text-xs tracking-wider uppercase mb-1">Get in Touch</h3>
          <p className="text-slate-400 text-sm">Have questions? Reach out to our support team.</p>
          <div className="space-y-4 text-sm text-slate-400">
            <div className="flex items-start gap-3">
              <FaPhoneAlt className="h-4 w-4 text-slate-500 mt-1 shrink-0" />
              <span className="leading-snug">
                +91- 90XXX XXX88<br />
                <span className="text-slate-500 text-[11px] font-semibold">Mon - Sat: 10 AM - 4 PM</span>
              </span>
            </div>
            <div className="flex items-center gap-3">
              <FaEnvelope className="h-4 w-4 text-slate-500 shrink-0" />
              <a href="mailto:contact@studentera.online" className="hover:text-white transition-colors truncate font-semibold">
                contact@studentera.online
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-500 font-semibold uppercase tracking-wider">
        <p>© {new Date().getFullYear()} Student Era. All rights reserved.</p>
        <p>Verified Training & Internship Partner</p>
      </div>
    </footer>
  );
};

export default Footer;